import { render } from "./MapYandex.vue?vue&type=template&id=610d076d"
import script from "./MapYandex.vue?vue&type=script&lang=js"
export * from "./MapYandex.vue?vue&type=script&lang=js"

import "./MapYandex.vue?vue&type=style&index=0&id=610d076d&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__